import { hsaSiteConfig } from '../config/hsa/site.config';

export const environment = {
  production: false,
  x_api_key: 'SW7ijp2I13DScTLmo6JvWsiBWdiwmXWa',
  apiUrl: 'https://api-healthsuite-qa.kozaca.com.ar/api',
  apiUrl_photo: 'https://api-healthsuite-qa.kozaca.com.ar',
  portalUrl: 'https://portal-paciente-healthsuite-qa.kozaca.com.ar',
  auth: {
    clientId: '019bfb61-02fc-7254-b7f5-a7462b0071b5',
    clientSecret: 'Mga7KuKGAWNKrH8elcZvlYME1riZeJvqZ0cAClJg',
  },
  siteConfig: hsaSiteConfig,
};
